<template>
  <div>
    <div class="banner" :style="cover">
      <h1 class="banner-title">设置</h1>
    </div>
    <v-card class="blog-container blog_container_for_setting">
      <!-- <div>
        <div class="themeTitle">
          <h1 id="theme">主题</h1>
          <p class="descriptText">
            #
            设置网站主题，目前支持设置"亮色模式"(即日间模式)、"暗色模式"（即夜间模式）。
            将来可能支持更多配色的主题
          </p>
        </div>
        <div class="themeContainer">
          <el-radio-group v-model="themeRadio" @change="changeThemeButton">
            <el-radio-button label="light">亮色模式</el-radio-button>
            <el-radio-button label="dark">暗色模式</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <el-divider></el-divider> -->
      <div>
        <div class="normalTitle">
          <h1 id="notify">通知</h1>
          <p class="descriptText">
            #
            "通知"是由服务器端主动发送的一些异步的通知信息，比如AI问答、AI绘画、AI音频执行成功后，会发送通知到用户端，这样您在网站的任何页面，都可以及时了解到任务的执行结果。
          </p>
        </div>
        <div class="normalContainer">
          <div>
            <el-switch
              @change="changeNotifyButton"
              v-model="isOpenNotify"
              active-text="开启通知推送"
              inactive-text="关闭通知推送"
            >
            </el-switch>
          </div>
          <div style="margin-top: 12px">
            <el-switch
              @change="changeNotifySoundButton"
              :disabled="!isOpenNotify"
              v-model="isOpenNotifySound"
              active-text="开启通知声音"
              inactive-text="关闭通知声音"
            >
            </el-switch>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <div class="normalTitle">
          <h1 id="log">日志明细</h1>
          <p class="descriptText">
            #
            "日志明细"记录了配额消耗的使用明细，您可以选择打开或关闭该功能。请注意，关闭日志会导致无法获得积分
          </p>
        </div>
        <div class="normalContainer">
          <div>
            <el-switch
              @change="changeLogButton"
              v-model="isOpenLog"
              active-text="开启日志"
              inactive-text="关闭日志"
            >
            </el-switch>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <div class="normalTitle">
          <h1 id="chatgpt">AI问答</h1>
          <p class="descriptText"># 一些与"AI问答"页面有关的可配置项</p>
        </div>
        <div class="normalContainer">
          <div>
            <span style="margin-right: 12px">每页条数：</span>
            <el-input-number
              size="medium"
              v-model="chatgptPageSize"
              @change="changeChatgptPageSize"
              :min="1"
              :max="10"
              label="每页条数"
            ></el-input-number>
          </div>
          <el-divider></el-divider>
          <div>
            <el-switch
              v-model="enableStream"
              active-text="启用流式输出"
              inactive-text="关闭流式输出"
              @change="changeEnableStream"
            ></el-switch>
          </div>
          <el-divider></el-divider>
          <div>
            <v-row style="display: block; margin: 8px 0px">
              <p style="margin-bottom: 12px">自定义角色：</p>
              <p class="descriptText">
                <el-icon class="el-icon-link"></el-icon>
                <a
                  class="linkText"
                  href="https://www.aishort.top/community-prompts"
                  target="_blank"
                  >AI Short网站（提供一份简洁易用的AI指令列表）</a
                >
              </p>
            </v-row>
            <v-row
              v-for="item in roleList"
              :key="item.label"
              :label="item.label"
              :value="item.value"
              style="margin: 8px 0px"
            >
              <v-col>
                <v-row>
                  <v-col cols="3">
                    <v-text-field
                      label="角色名称"
                      :value="item.label"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      label="描述词"
                      :value="item.prompt"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="roleBtn">
                <v-row>
                  <v-col>
                    <div>
                      <v-icon color="red" @click="deleteRole(item.value)">
                        mdi-minus
                      </v-icon>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row style="margin: 8px 0px">
              <v-col>
                <v-row>
                  <v-col cols="3">
                    <v-text-field
                      label="角色名称"
                      v-model="addRoleLabel"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      label="描述词"
                      v-model="addRolePrompt"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="roleBtn">
                <v-row>
                  <v-col>
                    <div>
                      <v-icon
                        color="green"
                        @click="addRole(addRoleLabel, addRolePrompt)"
                      >
                        mdi-plus
                      </v-icon>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <div class="normalTitle">
          <h1 id="aiart">AI绘画</h1>
          <p class="descriptText"># 一些与"AI绘画"页面有关的可配置项</p>
        </div>
        <div class="normalContainer">
          <div>
            <span style="margin-right: 12px">每页条数：</span>
            <el-input-number
              size="medium"
              v-model="aiartPageSize"
              @change="changeAiArtPageSize"
              :min="1"
              :max="10"
              label="每页条数"
            ></el-input-number>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <div class="normalTitle">
          <h1 id="aiaudio">AI音频</h1>
          <p class="descriptText"># 一些与"AI音频"页面有关的可配置项</p>
        </div>
        <div class="normalContainer">
          <div>
            <span style="margin-right: 12px">每页条数：</span>
            <el-input-number
              size="medium"
              v-model="aiaudioPageSize"
              @change="changeAiAudioPageSize"
              :min="1"
              :max="10"
              label="每页条数"
            ></el-input-number>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <div class="normalTitle">
          <h1 id="decoration">装饰</h1>
          <p class="descriptText">
            # 控制网站装饰品的显示或隐藏
          </p>
        </div>
        <div class="normalContainer">
          <div>
            <el-switch
              @change="changeLanternButton"
              v-model="isOpenLantern"
              active-text="显示灯笼"
              inactive-text="隐藏灯笼"
            >
            </el-switch>
          </div>
        </div>
      </div>
    </v-card>
    <audio
      controls="controls"
      hidden
      src="@/assets/sounds/notify.wav"
      ref="audio"
    ></audio>
  </div>
</template>

<script>
import {
  userConfigUpdate,
  userConfigGet,
  getCustomRole,
  deleteCustomRole,
  addCustomRole,
} from "../../api";
import { nextTick } from "vue";
export default {
  metaInfo: {
    meta: [
      {
        name: "keyWords",
        content:
          "兮游,seayouth,兮游博客,seayouth博客,chatgpt,AI绘图,AI作品图集,AI语音,游戏模拟器", //变量或字符串
      },
      {
        name: "description",
        content:
          "一个专注于AI技术分享的博客平台,无论您是AI爱好者、学者、开发者，还是对AI应用有兴趣的读者，这里都能为您提供有价值的内容和思考",
      },
    ],
  },
  data: function() {
    return {
      themeRadio: "light",
      isOpenNotify: false,
      isOpenNotifySound: false,
      isOpenLog: true,
      chatgptPageSize: 5,
      enableStream: true,
      aiartPageSize: 5,
      aiaudioPageSize: 5,
      userConfig: null,
      roleList: [],
      addRolePrompt: "",
      addRoleLabel: "",
      rules: {
        required: (value) => !!value || "必填",
      },
      isOpenLantern: false,
    };
  },
  mounted() {
    this.getConfig();
    this.getCustomRole();
    this.scrollToIndex();
  },
  methods: {
    scrollToIndex() {
      let hash = window.location.hash;
      if (hash.indexOf("#") != -1) {
        nextTick(() => {
          let id = hash.split("#")[1];
          id = decodeURIComponent(id);
          let el = document.getElementById(id);
          console.log("滚动到：", id, el);
          if (el) {
            // 平滑滚动
            setTimeout(() => {
              el.scrollIntoView({ behavior: "smooth" });
            }, 0);
          }
        });
      }
    },
    addRole(label, prompt) {
      if (label == undefined || label == "") {
        this.$notify({
          message: "角色名称不能为空！",
          type: "warning",
          showClose: true,
          position: "bottom-right",
          duration: 0,
        });
        return;
      }
      if (prompt == undefined || prompt == "") {
        this.$notify({
          message: "描述词不能为空！",
          type: "warning",
          showClose: true,
          position: "bottom-right",
          duration: 0,
        });
        return;
      }
      addCustomRole({
        label: label,
        value: "custom-" + label,
        prompt: prompt,
        description: prompt,
      })
        .then((res) => {
          this.$notify({
            message: "新增自定义角色成功！",
            type: "success",
            showClose: false,
            position: "bottom-right",
            duration: 2000,
          });
          this.addRoleLabel = "";
          this.addRolePrompt = "";
          this.getCustomRole();
        })
        .catch((err) => {
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    deleteRole(value) {
      deleteCustomRole({
        value: value,
      })
        .then((res) => {
          this.$notify({
            message: "删除自定义角色成功！",
            type: "success",
            showClose: false,
            position: "bottom-right",
            duration: 2000,
          });
          this.getCustomRole();
        })
        .catch((err) => {
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    playNotifySound() {
      this.$refs.audio.currentTime = 0;
      this.$refs.audio.play();
    },
    getCustomRole() {
      getCustomRole({})
        .then((res) => {
          this.roleList = res.data;
        })
        .catch((err) => {
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    getConfig() {
      userConfigGet({})
        .then((res) => {
          this.userConfig = res.data;
          this.isOpenLantern =
            this.userConfig.decoration?.isOpenLantern ?? false;
          // console.log(this.cascaderValue)
          // if (this.userConfig.theme.themeMode == "light") {
          //   this.$vuetify.theme.dark = false;
          //   this.themeRadio = "light";
          // } else if (this.userConfig.theme.themeMode == "dark") {
          //   this.$vuetify.theme.dark = true;
          //   this.themeRadio = "dark";
          // }
          this.isOpenNotify = this.userConfig.notify.isOpenNotify;
          this.isOpenNotifySound = this.userConfig.notify.isOpenNotifySound;
          this.isOpenLog = this.userConfig.log.isOpenLog;
          this.chatgptPageSize = this.userConfig.chatgpt.pageSize;
          this.enableStream = this.userConfig.chatgpt.enableStream;
          this.aiartPageSize = this.userConfig.aiart.pageSize;
          this.aiaudioPageSize = this.userConfig.aiaudio.pageSize;
        })
        .catch((err) => {
          this.$store.state.loginFlag = false;
          // this.$toast({ type: "error", message: err.message });
          if (err.message === "请先登录!") {
            this.$store.state.loginFlag = true;
          } else {
            this.$notify({
              message: err.message,
              type: "error",
              showClose: true,
              position: "bottom-right",
              duration: 0,
            });
          }
        });
    },
    changeAiAudioPageSize() {
      this.userConfig.aiaudio.pageSize = this.aiaudioPageSize;
      this.userConfigUpdate();
    },
    changeAiArtPageSize() {
      this.userConfig.aiart.pageSize = this.aiartPageSize;
      this.userConfigUpdate();
    },
    changeChatgptPageSize() {
      this.userConfig.chatgpt.pageSize = this.chatgptPageSize;
      this.userConfigUpdate();
    },
    changeEnableStream() {
      this.userConfig.chatgpt.enableStream = this.enableStream;
      this.userConfigUpdate();
    },
    changeThemeButton() {
      this.userConfig.theme.themeMode = this.themeRadio;
      this.userConfigUpdate();
    },

    changeNotifyButton() {
      this.userConfig.notify.isOpenNotify = this.isOpenNotify;
      this.userConfigUpdate();
    },
    changeNotifySoundButton() {
      this.userConfig.notify.isOpenNotifySound = this.isOpenNotifySound;
      if (this.isOpenNotifySound) {
        this.playNotifySound();
      }
      this.userConfigUpdate();
    },
    changeLogButton() {
      this.userConfig.log.isOpenLog = this.isOpenLog;
      this.userConfigUpdate();
    },
    changeLanternButton() {
      this.userConfig.decoration = {
        ...this.userConfig.decoration,
        isOpenLantern: this.isOpenLantern,
      };
      this.userConfigUpdate();
    },
    userConfigUpdate() {
      var postBody = {
        decoration: { isOpenLantern: this.userConfig.decoration.isOpenLantern },
        theme: { themeMode: this.userConfig.theme.themeMode },
        notify: {
          isOpenNotify: this.userConfig.notify.isOpenNotify,
          isOpenNotifySound: this.userConfig.notify.isOpenNotifySound,
        },
        log: { isOpenLog: this.userConfig.log.isOpenLog },
        chatgpt: {
          pageSize: this.userConfig.chatgpt.pageSize,
          enableStream: this.userConfig.chatgpt.enableStream,
        },
        aiart: { pageSize: this.userConfig.aiart.pageSize },
        aiaudio: { pageSize: this.userConfig.aiaudio.pageSize },
      };
      userConfigUpdate(postBody)
        .then((res) => {
          this.$store.commit("checkConfigInfo", postBody);
          // if (this.userConfig.theme.themeMode == "light") {
          //   this.$vuetify.theme.dark = false;
          // } else if (this.userConfig.theme.themeMode == "dark") {
          //   this.$vuetify.theme.dark = true;
          // }
        })
        .catch((err) => {});
    },
  },
  computed: {
    cover() {
      var cover = "";
      this.$store.state.blogInfo.pageList.forEach((item) => {
        if (item.pageLabel == "config") {
          cover = item.pageCover;
        }
      });
      return "background: url(" + cover + ") center center / cover no-repeat";
    },
  },
};
</script>

<style scoped>
.themeTitle {
}
.normalTitle {
  margin-top: 40px;
}

.themeContainer,
.normalContainer {
  margin: 24px 12px;
}

.descriptText {
  font-size: 12px;
  font-style: italic;
  padding: 12px;
  background-color: #cccccc20;
  color: #777777;
}

.themeTitle h1,
.normalTitle h1 {
  margin-bottom: 8px;
}

.roleBtn {
  height: 40px;
  text-align: center;
  margin: auto 8px;
  max-width: 30px;
  min-width: 30px;
}

.linkText {
  margin-left: 2px;
}
</style>
